import { Spinner } from "../Spinner";

export interface LoadingStateProps {
  label?: string;
  /** "spinner" (default) or "table" (skeleton rows — zero jank on the local box). */
  variant?: "spinner" | "table";
  rows?: number;
}

/** LoadingState — one of the 5 mandatory per-screen states (chargement). */
export function LoadingState({ label = "Chargement…", variant = "spinner", rows = 6 }: LoadingStateProps) {
  if (variant === "table") {
    return (
      <div className="nv-state nv-state--loading" role="status" aria-live="polite" aria-label={label}>
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "var(--nv-s-2)" }}>
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="nv-skeleton" style={{ height: 36 }} aria-hidden />
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className="nv-state nv-state--loading" role="status" aria-live="polite">
      <Spinner size="lg" label={label} />
      <div className="nv-state__desc">{label}</div>
    </div>
  );
}
